exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".guide-nav[data-v-7497348a]{font-family:DMSans-Medium, DMSans;font-weight:500;display:flex}.guide-nav .item[data-v-7497348a]{font-size:0.22rem;padding:0 0.3rem;line-height:0.6rem;cursor:pointer;color:rgba(255,255,255,0.85)}.guide-nav .active[data-v-7497348a]{color:#fff;position:relative;font-family:DMSans-Bold, DMSans;font-weight:bold}.guide-nav .active[data-v-7497348a]::after{content:\"\";position:absolute;left:0.3rem;right:0.3rem;bottom:0.15rem;height:2px;background:linear-gradient(90deg, #38F4BA 0%, #34DAC5 100%)}\n", ""]);

// exports
